import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ChatWindow from './ChatWindow';
import SupportView from './SupportView';
import { FaMoon, FaSun } from 'react-icons/fa';

const ChatApp = () => {
  const storedMode = localStorage.getItem('darkMode') === 'true';
  const [darkMode, setDarkMode] = useState(storedMode);
  const [activeView, setActiveView] = useState('chat'); // 'chat' | 'support'

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem('darkMode', newDarkMode); // Save to local storage
  };

  useEffect(() => {
    localStorage.setItem('darkMode', darkMode); // Update local storage when darkMode changes
  }, [darkMode]);

  const handleMenuClick = (view) => {
    setActiveView(view);
    setMobileMenuOpen(false); // Close menu on selection on mobile
  };

  return (
    <div className={`app ${darkMode ? 'dark-mode' : 'light-mode'}`}>
      <h1 style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', border: '0' }}>
        Edutap - Fast & Secure Student Payments via Chat
      </h1>
      {/* Sidebar (Desktop & Mobile Menu) */}
      <div className={`sidebar ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          <img src="/edutap-light.png" alt="Logo" className="sidebar-logo-banner" />
        </div>
        <div className="sidebar-menu">
          <div
            className={`menu-item ${activeView === 'chat' ? 'active' : ''}`}
            onClick={() => handleMenuClick('chat')}
          >
            <span>💬</span> Chat to Pay
          </div>
          <div
            className={`menu-item ${activeView === 'support' ? 'active' : ''}`}
            onClick={() => handleMenuClick('support')}
          >
            <span>📞</span> Support Details
          </div>
        </div>
        <div className="sidebar-footer">
          <div className="footer-controls">
            <div onClick={toggleDarkMode} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '30px' }}>
              {darkMode ? <FaSun color="#fbbf24" /> : <FaMoon />}
              <span>{darkMode ? 'Light Mode' : 'Dark Mode'}</span>
            </div>
          </div>
          <p>© {new Date().getFullYear()} Paysnug Africa</p>
        </div>
      </div>

      {/* Main Chat Area */}
      <div className={`chat-main-area ${mobileMenuOpen ? 'mobile-hidden' : ''}`}>
        {activeView === 'chat' ? (
          <ChatWindow darkMode={darkMode} onBack={() => setMobileMenuOpen(true)} />
        ) : (
          <SupportView darkMode={darkMode} onBack={() => setMobileMenuOpen(true)} />
        )}
      </div>
    </div>
  );
};

export default ChatApp;
